export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            ...(props?.TileDisplayMode === 'Full Width' ? {
                marginTop: 0,
                marginBottom: 0
            } : {
                marginTop: { base: 6, lg: 8 },
                marginBottom: { base: 6, lg: 8 }
            })
        },
        wrapper: {
            position: 'relative',
        },
        grid: {
            ...(props?.GridSize && {
                templateColumns: { base: 'repeat(1, 1fr)', lg: `repeat(${props?.GridSize}, 1fr)` }
            }),
            ...(props?.TileDisplayMode === 'Full Width' ? {
                gap: { base: 6, lg: 0 }
            } : {
                gap: { base: 6, lg: 2 }
            })
        },
        WidgetGridBlockTitleStyle: {
            marginBottom: { base: 4 }
        }
    })
}
